import { mqMin, tok, tokPx } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'
import { Footer } from '@/scopes/common/components'
import { Header } from '@/scopes/common/components/Header'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const ContentWrapper = styled.main`
  background-color: ${tok('semantics_views_tinted_background_color')};
  flex-grow: 1;
  min-height: ${tokPx('primitives_area_size_400')};
`

const Content = styled.div`
  max-width: ${tokPx('primitives_area_size_1440')};
  margin: 0 auto;
  color: ${tok('semantics_content_color')};
  padding: ${tokPx('primitives_space_16')} ${tokPx('primitives_space_16')} ${tokPx('primitives_space_32')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: ${tokPx('primitives_space_24')} ${tokPx('primitives_space_32')} ${tokPx('primitives_space_32')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${tokPx('primitives_space_32')} ${tokPx('primitives_space_48')} ${tokPx('primitives_space_48')};
  }
`

const Title = styled(Typography)`
  ${Typography.modVariant('display-g-regular')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    ${Typography.modVariant('display-f-regular')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    ${Typography.modVariant('display-e-regular')};
  }
`

const FooterStyled = styled(Footer)`
  background-color: ${tok('semantics_views_tinted_background_color')};
`

const TitleContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${tokPx('primitives_space_24')};
  gap: ${tokPx('primitives_space_16')};
  flex-direction: column;
  align-items: flex-start;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    align-items: center;
    flex-direction: row;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    margin-bottom: ${tokPx('primitives_space_32')};
  }
`

interface BookingsOverviewLayoutProps {
  children: React.ReactNode
  actions?: React.ReactNode
  banner?: React.ReactNode
}

export function BookingsOverviewLayout({
  children,
  actions,
  banner,
}: BookingsOverviewLayoutProps) {
  const intl = useIntl()

  return (
    <Wrapper>
      <Header hideLiveSearch />
      <ContentWrapper id="main-content" tabIndex={-1}>
        <Content>
          {banner}
          <TitleContainer>
            <Title forwardedAs="h1">{intl.formatMessage({ id: 'bookings_overview_title' })}</Title>
            {actions}
          </TitleContainer>
          {children}
        </Content>
      </ContentWrapper>
      <FooterStyled />
    </Wrapper>
  )
}
